import { c as _c } from "react/compiler-runtime";
import type { HTMLAttributes } from 'react';
import { Icon, type IconType } from '@/app/components/icons';
import { baseGridClassName, rowGapClassName } from '@/app/lcv/components/sections/compare/styles';
import { PRODUCT_COMPARE_DATA_TEST } from '@/app/lcv/components/sections/compare/tracking';
import type { CompareListProps } from '@/app/lcv/components/sections/compare/types';
import { getCompareModelField } from '@/app/lcv/components/sections/compare/utils';
import { COMPARE_SUMMARY } from '@/app/lcv/contents/compare';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { stripPTags } from '@/app/utils/format';
interface SummaryCardItemProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  icon?: IconType;
  value: string;
  className?: string;
}
const parsedNoToDash = (value: string) => {
  const stripped = stripPTags(value);
  return stripped === 'ไม่มี' ? '-' : stripped;
};
const parsedSummaryValue = (value: unknown) => {
  if (!value || typeof value !== 'string') {
    return '-';
  }
  return parsedNoToDash(value).replace(/<br\s*\/?>/gi, '<br>');
};
const SummaryCardItem = t0 => {
  const $ = _c(20);
  let className;
  let icon;
  let rest;
  let title;
  let value;
  if ($[0] !== t0) {
    ({
      title,
      icon,
      value,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = icon;
    $[3] = rest;
    $[4] = title;
    $[5] = value;
  } else {
    className = $[1];
    icon = $[2];
    rest = $[3];
    title = $[4];
    value = $[5];
  }
  let t1;
  if ($[6] !== className) {
    t1 = cn("flex flex-col items-center text-center", className);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== icon) {
    t2 = !!icon && <Icon icon={icon} size="lg" className="mb-2" />;
    $[8] = icon;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== title) {
    t3 = <span className="text-caption">{title}</span>;
    $[10] = title;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== value) {
    t4 = <b dangerouslySetInnerHTML={{
      __html: value
    }} />;
    $[12] = value;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== rest || $[15] !== t1 || $[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
    t5 = <div {...rest} className={t1}>{t2}{t3}{t4}</div>;
    $[14] = rest;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};
export const CompareSummaryList = t0 => {
  const $ = _c(8);
  const {
    values,
    lineupModelsGroup
  } = t0;
  const title = COMPARE_SUMMARY.title;
  const summaryList = COMPARE_SUMMARY.items;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = createDataAttributes({
      test: PRODUCT_COMPARE_DATA_TEST.summary
    });
    t2 = <h2 role="rowheader" className="font-noto-bold text-body-1 py-4 text-red-500">{title}</h2>;
    t3 = cn(baseGridClassName, rowGapClassName, "text-body-2 py-4 text-center");
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== lineupModelsGroup || $[4] !== values) {
    t4 = summaryList.map((item, index) => values.map((value, valueIndex) => {
      const summaryValue = getCompareModelField(lineupModelsGroup[value], item.fieldKey);
      return <SummaryCardItem key={`${index}${valueIndex}`} title={item.title} icon={item.icon} value={parsedSummaryValue(summaryValue)} className={cn({
        "hidden lg:flex": valueIndex === 2
      })} {...createDataAttributes({
        test: `${PRODUCT_COMPARE_DATA_TEST.summary}-${item.fieldKey}-${valueIndex}`
      })} role="cell" />;
    }));
    $[3] = lineupModelsGroup;
    $[4] = values;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div role="rowgroup" className="py-6" {...t1}>{t2}<div className={t3} role="row">{t4}</div></div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};